// Gelir & Gider Yönetimi sayfası ve pencereleri. Excel dosyaları ve kayıtlı
// değerler ('Alındı', 'Beklemede', 'Ödendi', 'Pasif', kaynak/kategori seçenekleri) Türkçe kalır.
const budget = {
  page: {
    title: 'Gelir & Gider Yönetimi',
    subtitle: 'E-fatura gelirleri ve giderleri, ödeme durumları ve istatistikler.',
  },
  types: {
    income: 'Gelir',
    expense: 'Gider',
  },
  status: {
    received: 'Alındı',
    pending: 'Beklemede',
    paid: 'Ödendi',
    cancelled: 'İptal',
    waiting: 'Bekleyen',
    active: 'Aktif',
    passive: 'Pasif',
  },
  common: {
    cancel: 'İptal',
    giveUp: 'Vazgeç',
  },
  actions: {
    addIncome: 'Yeni Gelir',
    addExpense: 'Yeni Gider',
    importIncome: 'Gelir Excel Yükle',
    importIncomeHint: 'Giden e-fatura Excel dosyasından gelirleri içe aktar',
    importExpense: 'Gider Excel Yükle',
    importExpenseHint: 'Gelen e-fatura Excel dosyasından giderleri içe aktar',
    excel: 'Tabloyu İndir',
    excelHint: 'Filtrelenmiş gelir ve giderleri Excel olarak indir',
    deleteAll: 'Tümünü Sil (Test)',
    deleteAllHint: 'TEST: Tüm gelir ve gider kayıtlarını sil',
  },
  stats: {
    receivedIncome: 'Alınan Gelir (Aktif)',
    receivedIncomeShort: 'Alınan gelir',
    pendingIncome: 'Bekleyen Gelir (Aktif)',
    pendingIncomeShort: 'Bekleyen gelir',
    paidExpense: 'Tamamlanan Ödeme (Aktif Gider)',
    paidExpenseShort: 'Ödenen gider',
    pendingExpense: 'Bekleyen Ödeme (Aktif Gider)',
    pendingExpenseShort: 'Bekleyen gider',
  },
  tabs: {
    label: 'Liste',
    income: 'Gelir Listesi',
    incomeShort: 'Gelir',
    expense: 'Gider Listesi',
    expenseShort: 'Gider',
  },
  toolbar: {
    search: 'Unvan, GİB No, ETTN, TCKN/VKN vb. ile ara…',
    searchShort: 'Fatura ara…',
    dateRange: 'Tarih aralığı',
    dateRangeHint: 'Kayıt tarihine (belge tarihi) göre süzer',
    startDate: 'Başlangıç tarihi',
    endDate: 'Bitiş tarihi',
  },
  table: {
    incomeLabel: 'Gelir listesi',
    expenseLabel: 'Gider listesi',
    emptyIncome: 'Filtrelere uygun gelir bulunamadı',
    emptyIncomeNone: 'Henüz bir gelir kaydı yok',
    emptyExpense: 'Filtrelere uygun gider bulunamadı',
    emptyExpenseNone: 'Henüz bir gider kaydı yok',
    rangeOf: '/ {{total}} kayıt',
    ofTotal: 'toplam {{total}} kayıt içinden',
    jump: 'Sayfaya git',
  },
  columns: {
    customerName: 'Müşteri Unvan',
    senderName: 'Unvan',
    gib: 'GİB Numarası',
    draft: 'Taslak No',
    scenario: 'Senaryo',
    invoiceType: 'Fatura Tipi',
    createdDate: 'Oluşturma Tarihi',
    createdTime: 'Oluşturma Zamanı',
    documentDate: 'Belge Tarihi',
    documentTime: 'Belge Zamanı',
    customerTax: 'Müşteri TCKN/VKN',
    senderTax: 'Gönderici TCKN/VKN',
    customerTag: 'Müşteri Etiketi',
    senderTag: 'Gönderici Etiketi',
    amount: 'Tutar',
    currency: 'Para Birimi',
    envelopeUuid: 'Zarf UUID',
    envelopeStatus: 'Zarf Durumu',
    ettn: 'ETTN',
    discount: 'İskonto',
    extraCosts: 'Fatura Dışı Masraflar',
    lineCount: 'Satır Sayısı',
    lineTotal: 'Birim Fiyat * Miktar Tutarı',
    payable: 'Ödenecek Tutar',
    taxExcluded: 'Vergiler Hariç Tutar',
    taxIncluded: 'Vergiler Dahil Tutar',
    paymentStatus: 'Ödeme Durumu',
    category: 'Kategori',
  },
  panel: {
    label: 'Seçili kayıt',
    heading: 'Kayıt',
    toggleStatus: 'Durumu Değiştir',
    statusLocked: 'Durum değiştirilemez',
    edit: 'Düzenle',
    delete: 'Sil',
    deleteHint: 'Kaydı Sil',
    deactivate: 'Pasif Yap',
    deactivateHint: 'Öğeyi pasif yap',
    activate: 'Aktif Et',
    activateHint: 'Öğeyi aktif et',
    attachment: 'Ek {{index}} / {{count}}',
    attachmentSize: 'Ek {{index}} / {{count}} · {{size}} KB',
  },
  delete: {
    title: 'Kaydı Sil',
    message: '{{name}} kaydını kalıcı olarak silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',
    confirm: 'Evet, Sil',
  },
  deleteAll: {
    title: 'Tüm Kayıtları Sil',
    message: 'Bütçe tablosundaki TÜM gelir ve gider kayıtları kalıcı olarak silinecek. Bu işlem geri alınamaz. Devam etmek istediğinize emin misiniz?',
    confirm: 'Evet, Tümünü Sil',
    deleting: 'Siliniyor…',
  },
  charts: {
    title: 'İstatistikler',
    subtitle: 'Tüm gelir ve gider kayıtları',
    incomeExpense: 'Gelir ve Gider Dağılımı',
    paymentStatus: 'Ödeme Durumu',
    category: 'Kategori Dağılımı',
    monthly: 'Aylık Trend',
    totalAmount: 'Toplam Miktar (₺)',
    other: 'Diğer',
  },
  form: {
    titleAddIncome: 'Yeni Gelir Ekle',
    titleAddExpense: 'Yeni Gider Ekle',
    subtitleAdd: 'E-fatura bilgilerini girin; isterseniz dosya ekleyin',
    sections: {
      invoice: 'Fatura Bilgileri',
      dates: 'Tarih & Zaman',
      customer: 'Müşteri Bilgileri',
      sender: 'Gönderici Bilgileri',
      amounts: 'Tutar Bilgileri',
      status: 'Durum',
      files: 'Dosya Ekle (İsteğe Bağlı)',
    },
    unvanPlaceholder: 'Unvan',
    scenarioPlaceholder: 'Ticari, Temel vb.',
    invoiceTypePlaceholder: 'SATIS, TEVKIFAT vb.',
    activeStatus: 'Aktif Durum',
    dropTitle: 'Dosyaları buraya sürükleyin veya tıklayın',
    dropHint: 'PDF, Word, Excel, resim ve diğer dosyalar',
    removeFile: 'Dosyayı kaldır',
    reset: 'Sıfırla',
    addIncome: 'Gelir Ekle',
    addExpense: 'Gider Ekle',
    adding: 'Ekleniyor…',
    titleEditIncome: 'Gelir Düzenle',
    titleEditExpense: 'Gider Düzenle',
    incomeName: 'Gelir Adı',
    incomeNamePlaceholder: 'Gelir adını giriniz',
    expenseName: 'Gider Adı',
    expenseNamePlaceholder: 'Gider adını giriniz',
    incomeSource: 'Gelir Kaynağı',
    incomeCategory: 'Gelir Kategorisi',
    source: 'Kaynak',
    spender: 'Harcama Yapan',
    expenseType: 'Gider Tipi',
    category: 'Kategori',
    amountPlaceholder: 'Tutar giriniz',
    incomeDate: 'Gelir Tarihi',
    expenseDate: 'Harcama Tarihi',
    status: 'Durum',
    choose: 'Lütfen Seçiniz',
    updateIncome: 'Gelir Güncelle',
    updateExpense: 'Gider Güncelle',
    updating: 'Güncelleniyor…',
  },
  import: {
    titleIncome: 'Excel’den Gelir İçe Aktar',
    titleExpense: 'Excel’den Gider İçe Aktar',
    subtitleIncome: 'Giden e-fatura listesi; aynı kayıtlar atlanır',
    subtitleExpense: 'Gelen e-fatura listesi; aynı kayıtlar atlanır',
    dropIncome: 'Giden E-Fatura Excel dosyasını buraya sürükleyin veya tıklayın',
    dropExpense: 'Gelen E-Fatura Excel dosyasını buraya sürükleyin veya tıklayın',
    formats: 'Desteklenen formatlar: .xlsx, .xls, .csv',
    ready: '{{count}} yeni satır içe aktarılacak. Toplam tutar: {{total}} ₺',
    customer: 'Müşteri',
    sender: 'Gönderici',
    date: 'Tarih',
    amount: 'Tutar',
    currencyShort: 'PB',
    more: '...ve {{count}} satır daha',
    checking: 'Mevcut kayıtlarla karşılaştırılıyor...',
    dupExisting: '{{count}} satır mevcut kayıtlarla birebir aynı olduğu için atlanacak.',
    dupInFile: '{{count}} satır dosya içinde tekrar ettiği için atlanacak.',
    nothingNew: 'Eklenecek yeni satır yok.',
    progress: 'İçe aktarılıyor: {{done}} / {{total}}',
    import: 'İçe Aktar',
    importCount: 'İçe Aktar ({{count}})',
    importing: 'İçe Aktarılıyor…',
    errorEmpty: 'Excel dosyası boş görünüyor.',
    errorFormatIncome: 'Bu dosya beklenen gelir formatında değil. TUTAR ve UNVAN sütunları bulunamadı.',
    errorFormatExpense: 'Bu dosya beklenen gider formatında değil. TUTAR ve GÖNDERİCİ UNVAN sütunları bulunamadı.',
    errorRead: 'Excel dosyası okunurken veya mevcut kayıtlarla karşılaştırılırken bir hata oluştu.',
  },
  toast: {
    loadError: 'Bütçeler yüklenirken bir hata oluştu',
    employeesError: 'Çalışanlar yüklenirken bir hata oluştu',
    nothingToExport: 'Dışa aktarılacak veri yok.',
    excelDone: 'Excel dosyası başarıyla indirildi',
    excelError: 'Excel dosyası indirilirken bir hata oluştu',
    addError: 'Öğe eklenirken bir hata oluştu',
    statusLocked: 'Bu durum değiştirilemez.',
    statusUpdated: 'Durum "{{status}}" olarak güncellendi.',
    statusError: 'Durum güncellenirken bir hata oluştu.',
    selectToEdit: 'Lütfen düzenlemek için bir öğe seçin.',
    nothingToDelete: 'Silinecek kayıt yok.',
    deletedAll: '{{count}} kayıt silindi.',
    deleteAllError: 'Tüm kayıtlar silinirken bir hata oluştu.',
    deleted: 'Kayıt başarıyla silindi.',
    deleteError: 'Kayıt silinirken bir hata oluştu.',
    activeUpdated: 'Öğe "{{status}}" olarak işaretlendi.',
    activeError: 'Aktif durum güncellenirken bir hata oluştu.',
    pageJumpInvalid: 'Lütfen 1 ile {{max}} arasında bir sayfa numarası girin.',
    incomeAdded: 'Gelir başarıyla eklendi!',
    incomeAddError: 'Gelir eklenirken bir hata oluştu!',
    expenseAdded: 'Gider başarıyla eklendi!',
    expenseAddError: 'Gider eklenirken bir hata oluştu!',
    incomeNotFound: 'Düzenlenecek gelir bulunamadı!',
    incomeUpdated: 'Gelir başarıyla güncellendi!',
    incomeUpdateError: 'Gelir güncellenirken bir hata oluştu!',
    expenseNotFound: 'Düzenlenecek gider bulunamadı!',
    expenseUpdated: 'Gider başarıyla güncellendi!',
    expenseUpdateError: 'Gider güncellenirken bir hata oluştu!',
    invalidExcel: 'Lütfen geçerli bir Excel dosyası seçin (xlsx, xls, csv).',
    allExist: 'Tüm satırlar zaten kayıtlı. Yeni kayıt eklenmedi.',
    incomeImported: '{{count}} gelir kaydı başarıyla içe aktarıldı.',
    expenseImported: '{{count}} gider kaydı başarıyla içe aktarıldı.',
    skippedRows: '{{count}} satır zaten kayıtlı olduğu için atlandı.',
    importError: 'İçe aktarma sırasında bir hata oluştu.',
  },
};

export default budget;
